import { render, staticRenderFns } from "./batchEditForm.vue?vue&type=template&id=360ccbd4&"
import script from "./batchEditForm.vue?vue&type=script&lang=js&"
export * from "./batchEditForm.vue?vue&type=script&lang=js&"
import style0 from "./batchEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports